import React from "react";
import { useNavigate } from "react-router-dom";
import SEO from "../../common-components/SEO";
const MarchUrban = () => {
  const navigate = useNavigate();
  return (    <>
      <SEO
        fullTitle={"M.Arch — Urban Design | McGAN'S Ooty School of Architecture"}
        description={"M.Arch in Urban Design at McGAN'S Ooty develops leaders in sustainable urbanism — studio-based research, fieldwork and policy engagement in the Nilgiris context."}
        keywords={`M.Arch Urban Design, urban design program, McGAN'S Ooty, sustainable urbanism, postgraduate architecture`}
        image={"https://mcgansarch.com/assets/images/academics/4.webp"}
        url={"https://mcgansarch.com/march-urban"}
      />
    <div className="container" style={{ padding: '60px 0' }}>
      <h1>Master of Architecture (M.Arch) in Urban Design</h1>
      <div className="details-images" style={{ padding: '60px 0' }}>
        <div className="row">
          <div className="col-lg-4 col-md-4">
            <img
              src="assets/images/academics/4.webp"
              title="AC4"
              alt="AC4"
              width={416}
              height={360}
            />
          </div>
          <div className="col-lg-4 col-md-4">
            <img
              src="assets/images/academics/DSC07518.JPG"
              title="AC5"
              alt="AC5"
              width={416}
              height={360}
            />
          </div>
          <div className="col-lg-4 col-md-4">
            <img
              src="assets/images/academics/DSC07468.JPG"
              title="AC6"
              alt="AC6"
              width={416}
              height={360}
            />
          </div>
        </div>
      </div>
      <h2>Shape the Future of Our Cities at McGans Ooty School of Architecture</h2>
      <p>
        Welcome to the Master of Architecture (M.Arch) in Urban Design program at McGans Ooty School of Architecture, where we cultivate visionary leaders prepared to address the complex challenges and opportunities facing urban environments worldwide. Our program offers a comprehensive, interdisciplinary approach, blending rigorous architectural design principles with critical urban strategies to create sustainable, resilient, and equitable cities.
      </p>
      <h3>Program Overview</h3>
      <p>
        The M.Arch in Urban Design is a post-professional degree designed for individuals with a foundational background in architecture or a related design field. This two-year (four-semester) program provides an advanced understanding of urban dynamics, spatial analysis, design intervention, and policy implementation.
      </p>
      <p>
        Our curriculum emphasises a holistic city view, exploring its social, economic, environmental, and cultural dimensions. Students will engage with real-world urban problems, developing innovative design solutions and strategic plans that contribute to the well-being of communities and the health of our planet.
      </p>
      <h3>Why Choose Our Program at McGAN’s Ooty?</h3>
      <ul>
        <li><b>Studio-Based Learning:</b> A significant portion of the program is dedicated to hands-on studio projects, allowing students to apply theoretical knowledge to practical urban design challenges.</li>
        <li><b>Focus on Sustainability & Resilience:</b> Our curriculum is deeply rooted in principles of sustainable urban development, preparing students to design for a changing climate and evolving societal needs.</li>
        <li><b>Expert Faculty:</b> Learn from renowned academics and industry professionals who bring cutting-on-edge research and practical experience to the classroom.</li>
        <li><b>Real-World Engagement:</b> Opportunities for site visits, community engagement initiatives, and collaborations with government bodies and private firms provide invaluable practical exposure.</li>
        <li><b>Unique Ooty Context:</b> Located in the picturesque Nilgiris, McGAN’s Ooty School of Architecture offers a unique academic environment. Students benefit from studying urbanism in a region that presents fascinating examples of hill station planning.</li>
      </ul>
      <div class="regiStartion-and-fee">
        <h3>Eligibility</h3>

        <div class="list">
          <ul>
            <li>
              <i className="ri-checkbox-circle-line iconStyle"></i>
              Degree:
              Candidates must hold a Bachelor’s Degree in Architecture (B.Arch) from a recognized university or institution.

            </li>
            <li>
              <i className="ri-checkbox-circle-line iconStyle"></i>
              Academic Qualification:
              A minimum of 50% aggregate marks in the qualifying degree is required.
              (For SC/ST candidates, a minimum of 45% is acceptable as per regulations.)

            </li>
            <li>
              <i className="ri-checkbox-circle-line iconStyle"></i>{" "}
              Entrance Examination:
              Applicants must possess a valid score in the Post Graduate Entrance Test in Architecture (PGETA) conducted by the Council of Architecture (CoA).
            </li>

          </ul>
        </div>
      </div>
      <div className="row regiStartion-and-fee mt-4">
        <div className="col-lg-12">
          <h3>M.Arch(Urban Design) Regulations & Downloads</h3>
          <div className="list">
            <ul>
              <li>
                <i className="ri-file-pdf-line iconStyle"></i>{" "}
                <a
                  href="assets/images/doc/M.Arch-UD-Regulations-2025.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="pdf-link"
                >
                  M.Arch Regulations( Urban Design) – 2025
                </a>
              </li>

            </ul>
          </div>
        </div>
      </div>
      <div className="row regiStartion-and-fee">
        <div className="col-6">
          <h3>How to Apply :</h3>
          <div className="list">
            <ul>
              <li>
                <i className="ri-checkbox-circle-line iconStyle"></i>{" "}
                Review the application requirements carefully.
              </li>
              <li>
                <i className="ri-checkbox-circle-line iconStyle"></i>{" "}
                Gather and prepare all required documents.
              </li>
              <li>
                <i className="ri-checkbox-circle-line iconStyle"></i>{" "}
                Fill out the application form accurately.
              </li>
              <li>
                <i className="ri-checkbox-circle-line iconStyle"></i>{" "}
                Submit your application on time.
              </li>
              <li>
                <i className="ri-checkbox-circle-line iconStyle"></i>{" "}
                Follow up if needed to confirm submission.
              </li>
            </ul>
          </div>
        </div>


        <div className="col-6">
          <h3>Apply Application & Fees</h3>
          <div className="list">
            <ul>
              <button
                type="button"
                className="default-btn btn"
                onClick={() => navigate(`/march-application`)}
              >
                Apply Now <i className="flaticon-next"></i>
              </button>
            </ul>
          </div>
        </div>
      </div>
    </div>
    </>
  )
}

export default MarchUrban;
